import { createIcon } from '../createIcon';

export const LockedIconConfig = {
  name: 'LockedIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M952.32 512.951h-112.128v108.471c0 177.152-150.016 329.435-327.168 329.435s-329.435-152.283-329.435-329.435v-108.471h-112.128c-38.107 0-69.193-31.086-69.193-69.193v-444.27c0-38.107 31.086-73.728 69.193-71.461h880.859c38.107-2.267 69.193 33.353 69.193 71.461v444.27c0 38.107-31.086 69.193-69.193 69.193zM328.777 621.422c0.219 101.595 82.651 184.027 184.247 184.247 101.595 0 181.979-82.871 181.979-184.247v-108.471h-366.226v108.471zM904.558 72.923h-541.769c-25.088 0-34.231 11.41-34.231 36.498s9.143 36.498 34.231 36.498h541.769c25.088 0 45.641-11.41 45.641-36.498s-20.553-36.498-45.641-36.498v-0.073zM904.558 292.059h-541.769c-25.088 0-34.231 11.41-34.231 36.498s9.143 36.498 34.231 36.498h541.769c25.088 0 45.641-11.41 45.641-36.498s-20.553-36.498-45.641-36.498v-0.073z',
  yOffset: 64,
  xOffset: 0,
  transform: 'rotate(180 0 512) scale(-1 1)'
};

export const LockedIcon = createIcon(LockedIconConfig);

export default LockedIcon;